// Connection-state color mapping shared by the settings tab, the inbox badge
// and the channelRegistry statusIndicator.

export const normalizeState = state =>
  (state || '').toString().trim().toLowerCase();

const GREEN = {
  classes: 'bg-n-teal-3 text-n-teal-11',
  text: 'text-green-600',
  color: '#10b981',
};
const AMBER = {
  classes: 'bg-n-amber-3 text-n-amber-11',
  text: 'text-amber-600',
  color: '#f59e0b',
};
const SLATE = {
  classes: 'bg-n-alpha-2 text-n-slate-11',
  text: 'text-n-slate-11',
  color: '#64748b',
};
const RED = {
  classes: 'bg-n-ruby-3 text-n-ruby-11',
  text: 'text-rose-600',
  color: '#ef4444',
};

const STATE_STYLES = {
  ready: GREEN,
  starting: AMBER,
  connecting: AMBER,
  connected: AMBER,
  synchronizing: AMBER,
  stopping: AMBER,
  restarting: AMBER,
  reconnecting: AMBER,
  halting: AMBER,
  created: AMBER,
  unverified: AMBER,
  unprepared: AMBER,
  stopped: SLATE,
  paused: SLATE,
  disconnected: RED,
  failed: RED,
  unreachable: RED,
  banned: RED,
};

const DEFAULT_STYLE = {
  classes: 'bg-n-alpha-2 text-n-slate-11',
  text: 'text-n-slate-11',
  color: '#94a3b8',
};

const styleFor = state => STATE_STYLES[normalizeState(state)] || DEFAULT_STYLE;

export const getStateColorClasses = state => styleFor(state).classes;

export const getStateTextClass = state => styleFor(state).text;

export const getStateColor = state => styleFor(state).color;
